import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';
import ButtonBase from '../../../components/Buttons/ButtonBase';

const styles = () => ({
  TextField: {
    maxWidth: '536px',
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296,
      padding: 0,
    },
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    marginTop: 39,
    '@media screen and (max-width: 600px)':{
      paddingRight:18
    }
  },
});

const SocialNetworksForm = props => {

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    classes,
  } = props;

  useEffect(() => {
    const abortController = new AbortController()
    return function cleanup() {
      abortController.abort()
    }
  }, [])

  return (
    <form>
      <Grid
        container
        direction="column"
        classes={{ root: classes.Grid }}
      >
  
        <TextField
          label="Perfil de LinkedIn"
          id="linkedIn"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.linkedIn}
          helperText={touched.linkedIn && errors.linkedIn ? errors.linkedIn : ''}
          error={touched.linkedIn && errors.linkedIn ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />
                  
        <TextField
          label="Perfil de Twitter"
          id="twitter"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.twitter}
          helperText={touched.twitter && errors.twitter ? errors.twitter : ''}
          error={touched.twitter && errors.twitter ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <TextField
          label="Perfil de Facebook"
          id="facebook"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.facebook}
          helperText={touched.facebook && errors.facebook ? errors.facebook : ''}
          error={touched.facebook && errors.facebook ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <TextField
          label="Perfil de Instagram"
          id="instagram"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.instagram}
          helperText={touched.instagram && errors.instagram ? errors.instagram : ''}
          error={touched.instagram && errors.instagram ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <TextField
          label="Canal de Youtube"
          type="text"
          id="youtube"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.youtube}
          helperText={touched.youtube && errors.youtube ? errors.youtube : ''}
          error={touched.youtube && errors.youtube ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />
      </Grid>

      <div className="horizontal-layout-SocialNetworks" style={{ marginTop: 15 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
           disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </div>
    </form>
  );
};

export default withStyles(styles)(SocialNetworksForm);